import { InfoTooltip } from '@/components/cards/cardKit';

/** Keep the coverage verdict beside the rows; detailed evidence belongs in
 * the shared help layer, where it cannot resize the table or empty state. */
export function UsTradeCoverageNotes({ summary, notes, detail }: {
  summary: string;
  notes: readonly string[];
  detail?: string;
}) {
  if (!summary) return null;
  const explained = notes.length > 0 && (notes.join(' · ') !== summary || !!detail);
  return <span className="text-muted-foreground inline-flex flex-wrap items-center gap-1.5 text-xs" data-testid="us-trades-notes">
    <span>{summary}</span>
    {explained && <InfoTooltip title="US trade coverage">
      {notes.map(note => <p key={note}>{note}</p>)}
      {detail && <p className="mt-1 break-words">{detail}</p>}
    </InfoTooltip>}
  </span>;
}
